import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseListApiService } from '@common/api/base-list-api.service';
import { ResultApi } from '@common/api/result-api';

import { UserApi } from './models/back/user-api';
import { AppConstants } from '../../app.constants';

@Injectable({
    providedIn: 'root'
})
export class UsersListApiService extends BaseListApiService<UserApi>
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlAuth;
        this.resourceUrl = '/auth/users';
    }

    getUsers (qs: string): Observable<ResultApi<UserApi>>
    {
        return this.getAll(`${this.resourceUrl}${qs}`);
    }

    searchUsers (qs: string)
    {
        return this.getAll(`${this.resourceUrl}/search${qs}`);
    }
}
